const API_BASE_URL = 'https://admin.techieinteriors.co.ke/api/v1';

export default API_BASE_URL;
